
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/faq-page",
      function () {
        return require("private-next-pages/faq-page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/faq-page"])
      });
    }
  